<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="form-group row">
        <reg-input-text
          v-if="fields[0]"
          label="Group Name"
          :form="form"
          :field="fields[0]"
          placeholder="Enter Group Name"
          :api-errors="apiErrors"
          :rules="{ required: fields[0].required }"
        />
        <reg-input-text
          v-if="fields[1]"
          label="Estimate Number of Members"
          :form="form"
          :field="fields[1]"
          placeholder="eg: 10"
          :api-errors="apiErrors"
          :rules="checkValidation()"
        />
      </div>

      <div class="form-group row contribution-wrapper">
        <reg-input-date-picker
          v-if="fields[2]"
          label="Desired Start Date"
          :form="form"
          :field="fields[2]"
          :api-errors="apiErrors"
          placeholder="MM/DD/YYYY"
          date-format="MM/DD/YYYY"
          :rules="{ required: fields[2].required }"
        />
        <div class="col-xxl-6 xol-xl-6 col-lg-6 col-md-6 group-contribution-wrapper">
          <label for="">
            Is the group contributing to the payment?
            <span class="required">*</span>
          </label>
          <reg-input-radio
            v-if="fields[6]"
            label=""
            labelName=""
            :form="form"
            :field="fields[6]"
            :api-errors="apiErrors"
            :options="groupContributionOptions"
            :rules="{ required: fields[6].required }"
            @inputHandler="handleGroupContribution"
            inputClass="col-xxl-3 col-xl-3 col-lg-3 col-md-6 mb-0 wrapper-input"
          />
        </div>
      </div>
      <div class="form-group row">
        <reg-input-select
          v-if="fields[3]"
          label="Group Type"
          :form="form"
          :field="fields[3]"
          :options="filteredGroupTypes.map((type) => type.value)"
          :custom-label.sync="(opt) => filteredGroupTypes.find((x) => x.value == opt).name"
          placeholder="Select Group Type"
          :api-errors="apiErrors"
          :rules="{ required: fields[3].required }"
        />
        <reg-input-select
          v-if="fields[5]"
          label="Group Industry"
          :form="form"
          :field="fields[5]"
          :options="groupIndustries.map((type) => type.value)"
          :custom-label="(opt) => groupIndustries.find((x) => x.value == opt).name"
          placeholder="Select Industry"
          :api-errors="apiErrors"
          :rules="{ required: fields[5].required }"
        />
      </div>
      <div class="form-group">
        <reg-input-text
          v-if="fields[4]"
          label="Federal TAX ID Number(TIN/EIN)"
          semi-label="Social Security If Partnership"
          type="number"
          :form="form"
          :field="fields[4]"
          placeholder="Enter Federal TAX ID Number(TIN/EIN)"
          :api-errors="apiErrors"
          :rules="{ required: fields[1].required, digits: 9 }"
          form-group-class="mb-4"
          @input.native="enforceDigitLimit($event)"
          @keypress.native="onlyAllowDigits($event)"
          maxlength="9"
          inputmode="numeric"
          pattern="\d*"
        />
      </div>

      <div class="action-btn split-action mt-3">
        <button class="button-black" @click="backHandler" type="button">Back</button>
        <div class="action-next">
          <button class="button-green" @click.prevent="saveAndContinue" type="button">
            Save & Continue Later
          </button>
          <button class="button-blue" type="submit">Next</button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import axios from '@/utils/regAxios';
  import newAxios from 'axios';
  let axiosInstance = newAxios.create({ headers: '' });
  import RegInputDatePicker from '../utils/RegInputDatePicker.vue';
  import Screenshot from '@/utils/screenshot';
  import RegInputRadio from '../utils/RegInputRadio.vue';

  export default {
    components: { RegInputDatePicker, RegInputRadio },
    name: 'GroupInfoForm',
    props: {
      fields: {
        required: true,
      },
      form: {
        required: true,
      },
      groupIndustries: {
        required: true,
      },
      groupTypes: {
        required: true,
      },
    },
    computed: {
      groupCensusId() {
        return this.$store.getters.groupCensusId;
      },
      getGroupType() {
        return this.form.group_type;
      },
      filteredGroupTypes() {
        if (this.form.group_contribution === '1') {
          return this.groupTypes.filter((type) => type.value === 'employer');
        }
        return this.groupTypes.filter((type) => type.value !== 'employer');
      },
    },
    data: () => ({
      apiErrors: null,
      groupContributionOptions: [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
      ],
    }),
    methods: {
      enforceDigitLimit(event) {
        const raw = event.target.value;
        const digitsOnly = raw.replace(/\D/g, '').slice(0, 9);
        this.form[this.fields[4].name] = digitsOnly; // Assuming you want to apply the same logic to fax number
        // Also fix the displayed value (if your component doesn't sync automatically)
        event.target.value = digitsOnly;
      },

      onlyAllowDigits(event) {
        const key = event.key;
        // Allow: backspace, delete, tab, escape, enter, arrows, home, end
        if (
          [46, 8, 9, 27, 13, 37, 38, 39, 40, 35, 36].includes(event.keyCode) ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (event.ctrlKey === true && [65, 67, 86, 88].includes(event.keyCode))
        ) {
          return;
        }
        // Ensure it's a number and not more than 9 digits
        if (!/^\d$/.test(key) || event.target.value.length >= 9) {
          event.preventDefault();
        }
      },
      handleGroupContribution(contribution) {
        if (contribution == 1) {
          this.$store.commit('setRegGroupContribution', true);
          this.form.group_type = 'employer';
        } else {
          this.$store.commit('setRegGroupContribution', false);
        }
      },

      disabledBeforeToday(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today;
      },
      saveAndContinue() {
        this.$emit('onOpenSaveAndContinue', this.form);
      },
      backHandler() {
        this.$emit('onBackHandler');
      },
      async submit() {
        this.form.registration_id = this.$store.getters.regTempId;
        let loader = this.$loading.show();
        let formData = this.form;
        Screenshot.captureScreenShot(Screenshot.regScreenShotSelector)
          .then((res) => {
            if (res) {
              formData['screenshot'] = res;
            }
          })
          .finally(() => {
            loader.hide();
            const url = 'register/group-info';
            this.save(url, formData);
          });
      },
      async save(url, payload) {
        let loader = this.$loading.show();
        try {
          let res = await axios.post(url, payload);
          this.$store.commit('setRegGroupType', this.form.group_type);
          if (res.data.statusCode == 200) {
            this.$emit('onSuccess');
          }
        } catch (err) {
          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;
            setTimeout(() => {
              this.apiErrors = null;
            }, 5000);
          } else {
            this.$notify(err.response.data.message, 'Error', 'error');
          }
        } finally {
          loader.hide();
        }
      },
      checkValidation() {
        return this.groupCensusId ? `required|integer|min_value:10` : `required|integer`;
      },
    },
    created() {
      if (!this.$store.getters.regTempId) {
        this.backHandler();
      }
      if (this.fields[3]?.value) {
        this.form.group_type = this.fields[3].value;
      }
    },

    watch: {
      'form.group_contribution': {
        handler: function (val) {
          if (val == 1) {
            this.$store.commit('setRegGroupContribution', true);
            this.form.group_type = 'employer';

          } else if (val == 0 && this.fields[6].value == 0) {
            this.$store.commit('setRegGroupContribution', false);

            this.form.group_type = this.fields[3].value;
          } else {
            this.$store.commit('setRegGroupContribution', false);
            this.form.group_type = '';
          }
          this.$emit('updateGroupType', this.form.group_type? true : false);

        },
        deep: true,
      },
    },
  };
</script>

<style>
  .group-contribution-wrapper {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
  }
  .group-contribution-wrapper .required {
    color: red;
  }
  .wrapper-input .checkmark {
    border: 0.5px solid rgba(0, 0, 0, 0.25);
    width: 20px;
    height: 20px;
  }
</style>
